import { lazy } from "react";
import { Route } from "react-router-dom";
const SetNewPasswordAuthLayout = lazy(() => import("pages/v1/layout/security/SetNewPasswordAuthLayout"));
const SetNewPassword = lazy(() => import("./SetNewPassword"));
const SetNewPasswordError = lazy(() => import("./SetNewPasswordError"));

const SetNewPasswordRoutes =
	<>
		<Route element={<SetNewPasswordAuthLayout/>} >
			<Route path="/login/set-new-password" element={
				<SetNewPassword/>
			} />
		</Route>

		<Route path="/login/set-new-password-error" element={
			<SetNewPasswordError />
		} />
	</>

export default SetNewPasswordRoutes;